import React from "react";
import { motion } from "framer-motion";
import "./counseling-services.css";
import LazyBackground from "../../Lazy/lazy-background";

const CounselingServices = () => {
  // Animation variants for consistency
  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15, delayChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  return (
    <motion.section
      className="cs-section"
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/background13.svg`}
            alt=""
            className="home-background home-background7"
            loading="lazy"
          />
      <div className="cs-container">
        {/* Section Header */}
        <motion.div className="cs-header" variants={itemVariants}>
          <h2>Counseling Services</h2>
          <p>
            We believe everyone deserves clarity and support when navigating
            genetic information. That’s why we offer:
          </p>
        </motion.div>

        {/* Service Cards */}
        <div className="cs-cards-container">
          <motion.div className="cs-card" variants={itemVariants}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/share.svg`}
              alt="Post-Test Counseling Icon"
              className="cs-card-icon"
            />
            <h3>Post-Test Counseling</h3>
            <p className="cs-card-description">
              One complementary session is provided only when your test reveals
              an actionable insight — such as a risk that can be managed,
              treated, or further investigated.
            </p>
            <div className="cs-cost-section">
              <span className="cost-label">Cost</span>
              <span className="cost-value">Free (if applicable)</span>
            </div>
          </motion.div>

          <motion.div className="cs-card" variants={itemVariants}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/lifebuoy.svg`}
              alt="Pre-Test Counseling Icon"
              className="cs-card-icon"
            />
            <h3>Pre-Test Counseling</h3>
            <p className="cs-card-description">
              Optional session to discuss your family history, risks, and
              whether testing is right for you.
            </p>
            <div className="cs-cost-section">
              <span className="cost-label">Cost</span>
              <div className="cost-value-paid">
                <span>Paid Service</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* "Help You Understand" Section */}
        <div className="cs-understand-section">
          <motion.h3 variants={itemVariants}>
            Our counselors help you understand:
          </motion.h3>
          <motion.div className="cs-understand-pills" variants={sectionVariants}>
            <motion.div className="cs-understand-pill" variants={itemVariants}>
              What your results mean for you and your family
            </motion.div>
            <motion.div className="cs-understand-pill" variants={itemVariants}>
              Your risk for inherited conditions
            </motion.div>
            <motion.div className="cs-understand-pill" variants={itemVariants}>
              What next steps to consider — from lifestyle changes to further
              testing
            </motion.div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default CounselingServices;